module.exports = __webpack_public_path__ + "static/media/shift_eia_notes.42cdc171.png";